<template>
  <h6
    class="tm-form-line-label"
    :class="{
      [`tm-form-line-label--${fontSize}`]: fontSize,
      'tm-form-line-label--extra-height-md': extraHeightMd,
      'tm-form-line-label--required': required,
      'distinct--text': distinct,
      ellipsis,
    }"
  >
    <slot>
      <span>{{ label }}</span>
      <span
        v-if="additional"
        class="light--text font-weight-normal"
        v-text="` (${additional})`"
      />
    </slot>
  </h6>
</template>

<script setup lang="ts">
export type TmFormLineLabelFontSize = '14px' | '16px'

defineProps<{
  label?: string
  fontSize?: TmFormLineLabelFontSize
  additional?: string
  extraHeightMd?: boolean // when used in TmFormLine with leftLabel prop
  required?: boolean
  distinct?: boolean
  ellipsis?: boolean
}>()
</script>

<style lang="scss" scoped>
.tm-form-line-label {
  line-height: 20px;
  color: $emphasize;
  min-width: 0;
  flex-shrink: 0;
  max-width: 100%;

  &--14px {
    font-size: 14px;
  }

  &--16px {
    font-size: 16px;
  }

  &--extra-height-md {
    @include media-md-min {
      line-height: 32px;
    }
  }

  &--required:after {
    content: '*';
    color: $red600;
    font-weight: $semi-bold-font;
    margin-left: 2px;
  }

  &.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-shrink: 1;
  }
}
</style>
